import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import classes from '../pipeline.module.scss';
import Table from '../../../../_common/Tables/Table';
import { formattedDateTime } from '../pipelineHelpers';

const tableHeader = [
  {
    name: 'Note',
    path: 'note',
    render: (d) => (d.note
      ? (
        <div className={classes.history_note_cell}>
          {d.note}
        </div>
      )
      : '-'),
  },
  { name: 'Source', path: 'source' },
  { name: 'Created At', path: 'createdAt' },
  { name: 'Created By', path: 'changedBy' },
];

const NotesHistory = ({ history = [] }) => {
  const historyData = useMemo(() => [...history]
    .sort((a, b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf())
    .map((d) => ({
      ...d,
      createdAt: formattedDateTime(d.createdAt),
      source: d.source ? _.startCase(d.source) : '-',
      changedBy: d.ChangedByUser?.username || d.ChangedByUser?.name || '-',
    })), [history]);

  return (
    <div className={classes.history_wrapper}>
      <h3>{`Notes history (${historyData.length})`}</h3>

      <div className={classes.history_table}>
        <Table
          header={tableHeader}
          data={historyData}
        />
      </div>
    </div>
  );
};

NotesHistory.propTypes = {
  history: PropTypes.array,
};

export default NotesHistory;
